import { waitForElement } from '../../../../js/utils'

class ProgressBar {
  constructor() {
    // this.progressBar = document.querySelector('.en__p2p__progress')

    // if (!this.progressBar) {
    //   return
    // }

    waitForElement('.en__p2p__progress').then(() => {
      setTimeout(() => {
        const progressBar = document.querySelector('.en__p2p__progress')
        this.render(progressBar)
      }, 300)
    })
  }

  render(progressBar) {
    const progressBarHeading = progressBar?.previousElementSibling || null

    if (progressBarHeading) {
      this.wrapProgressBar(progressBarHeading, progressBar)
    } else {
      this.wrapProgressBar(progressBar)
    }
  }

  wrapProgressBar(...elements) {
    if (document.querySelector('.progress-bar-card')) {
      return
    }

    // creates a .card element to wrap the progress bar and heading and adds it to the DOM
    const card = document.createElement('div')
    card.classList.add('card', 'progress-bar-card')
    elements.forEach((element) => {
      element && card.appendChild(element)
    })
  }
}

export default ProgressBar
